import {FC, useContext, useState, useEffect } from 'react'
import { getUnidentifiedUsers, UnverifiedPeopleRecords } from "../dashboard-hooks";
import ConstantsContext from '../../../../store/Constants-context';

const UnverifiedPeople: FC<{date: Date;}> = ({date}) => {
    const constantsCtx = useContext(ConstantsContext)
    const [userCount, setUserCount] = useState(0);
    const [unidentifiedUsers, setUnidentifiedUsers] = useState<any[]>([]);
    const [userCountRecords, setUserCountRecords] = useState<{ room_name: string, count: number}[]>([]);

    useEffect(() => {
        getUnidentifiedUsers(date, constantsCtx, setUnidentifiedUsers);
    }, [date])

    useEffect(() => {
        UnverifiedPeopleRecords(unidentifiedUsers, setUserCount, setUserCountRecords)
    }, [unidentifiedUsers, date])

    return (
        <div className="col-xl-8 unverifiedPeople">
            <div className="card card-dashboard card-stretch">
            {/* begin::Body */}
            <div className='card-body py-9'>
                <div className="row">
                <div className="col-md-12">
                    <h4 className="py-3">Unverified People :</h4>
                </div>
                <div className="col-md-4 align-items-center d-flex flex-grow-1 justify-content-center m-b-0 m-t-0 teal-text">
                    <h1>{userCount}</h1>
                </div>
                <div className="col-md-8 text-center table-responsive" style={{maxHeight:"194px",overflowY:"auto"}}>
                    <table className="no-footer table align-middle gs-0 gy-5" id="tblUnidentified">
                        <tbody>
                        {userCount === 0 && <tr><td className="noRecords">No records available...</td></tr>}
                        {userCount > 0 && 
                            userCountRecords.map((rec: {room_name: string, count: number}) => 
                                <tr key={rec.room_name} style={{borderBottom: "2px solid #000"}}>
                                    <td><b>{rec.room_name}</b></td>
                                    <td>{rec.count}</td>
                                    <td>
                                        <a style={{cursor:"pointer"}} onClick={() => window.location.href=`students_room_rolls.html?name=`+ rec.room_name + `&date=` + date}>
                                            <i className="bi bi-chevron-right fs-1"></i>
                                        </a>
                                    </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export {UnverifiedPeople};